

export class RuleDto implements IRuleDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    rank!: number;
    designationId!: number | undefined;
    designation!: string | undefined;
    isActive!: boolean;

    constructor(data?: IRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.rank = _data["rank"];
            this.designationId = _data["designationId"];
            this.designation = _data["designation"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["rank"] = this.rank;
        data["designationId"] = this.designationId;
        data["designation"] = this.designation;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IRuleDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    rank: number;
    designationId: number | undefined;
    designation: string | undefined;
    isActive: boolean;
}

